import React from "react";
import {
    ShowController,
    ShowView,
    Show,
    SimpleShowLayout,
    TextField,
    DateField,
} from "react-admin";


import { connect } from 'react-redux';
import compose from 'recompose/compose';

import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import CloseIcon from "@material-ui/icons/Close";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

import ImportButton from './ImportCSVButton';


const showStyles = theme => ({
    root: {
        paddingTop: 40,
    },
    title: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        margin: "1em"
    },
    form: {
        [theme.breakpoints.up("xs")]: {
            width: 400
        },
        [theme.breakpoints.down("xs")]: {
            width: "100vw",
            marginTop: -30
        }
    },
    inlineField: {
        display: "inline-block",
        width: "50%"
    }
});



const CSVDetail = ({ classes, onCancel, ...props }) => (
         <div className={classes.root}>
                <div className={classes.title}>
                    <Typography variant="title">
                        Import CSV
                    </Typography>
                    <IconButton onClick={onCancel}>
                        <CloseIcon />
                    </IconButton>
                </div>
             <Card>
                 <CardContent>
                     <p>
                         File have to be a simple <strong>CSV</strong> file. The file has to have a header
                         and contains five elements per row.
                     </p>
                     <p>
                         <a target="_blank" href="/static/samples.csv">Example</a>
                     </p>
                     <ImportButton/>
                 </CardContent>
             </Card>
        </div>
);



export default withStyles(showStyles)(CSVDetail);
